require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-were-the-world-banks-key-messages-around-child.json") })
        }
      }, "path---en-us-update-what-were-the-world-banks-key-messages-around-child");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-were-the-world-banks-key-messages-around-child!./.cache/json/en-us-update-what-were-the-world-banks-key-messages-around-child.json
// module id = 858
// module chunks = 231608221292675